import { Typography } from 'antd'
import { type LinkProps as AntdLinkProps } from 'antd/lib/typography/Link'

type LinkProps = AntdLinkProps

export function Link(props: LinkProps) {
  return <Typography.Link {...props} />
}
